var _g, _g2, _g3, _g4, _g5, _g6, _path, _path2, _path3, _g7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoals(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_Goals",
    "data-name": "Icon/Goals",
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Path_Copy",
    "data-name": "Path Copy",
    transform: "translate(15 78)",
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50,2a2.25,2.25,0,0,0-2-2H1A1.125,1.125,0,0,0,0,1H0A1.125,1.125,0,0,0,1,2H49a1.125,1.125,0,0,0,1-1Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 50 1.999996662139893 C 50 1.807042717933655 49.95571517944336 1.609283208847046 49.8772087097168 1.416796445846558 C 49.95407485961914 1.282894968986511 50 1.13897967338562 50 1.000007748603821 L 50 1.999996662139893 Z M 49.0000114440918 1.999996662139893 L 0.9999889135360718 1.999996662139893 C 0.5285888910293579 1.999996662139893 0 1.471418857574463 0 1.000007748603821 C 0 0.5285966396331787 0.5285888910293579 1.885971505544148e-05 0.9999889135360718 1.885971505544148e-05 L 48.0000114440918 1.885971505544148e-05 C 48.74991226196289 1.885971505544148e-05 49.57209014892578 0.6687215566635132 49.8772087097168 1.416796445846558 C 49.69332885742188 1.737106323242188 49.33244323730469 1.999996662139893 49.0000114440918 1.999996662139893 Z",
    stroke: "none",
    fill: "#1a3f54"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Path_Copy_2",
    "data-name": "Path Copy 2",
    transform: "translate(41 62.995) rotate(90)",
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17,2a2.25,2.25,0,0,0-2-2H1A1.125,1.125,0,0,0,0,1H0A1.125,1.125,0,0,0,1,2H16a1.125,1.125,0,0,0,1-1Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 17 1.999997735023499 C 17 1.807042717933655 16.95571708679199 1.609283328056335 16.87720680236816 1.416796088218689 C 16.95407485961914 1.282894611358643 17 1.138979315757751 17 1.000007748603821 L 17 1.999997735023499 Z M 16.00000953674316 1.999997735023499 L 0.9999899864196777 1.999997735023499 C 0.5285900235176086 1.999997735023499 0 1.471417784690857 0 1.000007748603821 C 0 0.5285977721214294 0.5285900235176086 1.774860356817953e-05 0.9999899864196777 1.774860356817953e-05 L 15.00002002716064 1.774860356817953e-05 C 15.74990653991699 1.774860356817953e-05 16.57209014892578 0.6687193512916565 16.87720680236816 1.416796088218689 C 16.69332695007324 1.737106323242188 16.33244132995605 1.999997735023499 16.00000953674316 1.999997735023499 Z",
    stroke: "none",
    fill: "#1a3f54"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Path_Copy_3",
    "data-name": "Path Copy 3",
    transform: "translate(41 49.5) rotate(90)",
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.386,2a2.25,2.25,0,0,0-2-2H1A1.125,1.125,0,0,0,0,1H0A1.125,1.125,0,0,0,1,2H5.386a1.125,1.125,0,0,0,1-1Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6.386359214782715 1.999997735023499 C 6.386359214782715 1.807042717933655 6.342076301574707 1.609283447265625 6.263566493988037 1.416796207427979 C 6.340435028076172 1.282894730567932 6.386359214782715 1.138979315757751 6.386359214782715 1.000007748603821 L 6.386359214782715 1.999997735023499 Z M 5.386369228363037 1.999997735023499 L 0.99998939037323 1.999997735023499 C 0.5285893678665161 1.999997735023499 -6.310272055998212e-07 1.471417784690857 -6.310272055998212e-07 1.000007748603821 C -6.310272055998212e-07 0.5285977721214294 0.5285893678665161 1.774860356817953e-05 0.99998939037323 1.774860356817953e-05 L 4.386369228363037 1.774860356817953e-05 C 5.136264324188232 1.774860356817953e-05 5.958448886871338 0.668719470500946 6.263566493988037 1.416796207427979 C 6.079687118530273 1.737106442451477 5.71880054473877 1.999997735023499 5.386369228363037 1.999997735023499 Z",
    stroke: "none",
    fill: "#1a3f54"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Path_Copy_4",
    "data-name": "Path Copy 4",
    transform: "translate(41 7.807) rotate(90)",
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.386,2a2.25,2.25,0,0,0-2-2H1A1.125,1.125,0,0,0,0,1H0A1.125,1.125,0,0,0,1,2H5.386a1.125,1.125,0,0,0,1-1Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6.386359214782715 1.999997735023499 C 6.386359214782715 1.807042717933655 6.342076301574707 1.609283447265625 6.263566493988037 1.416796207427979 C 6.340435028076172 1.282894730567932 6.386359214782715 1.138979315757751 6.386359214782715 1.000007748603821 L 6.386359214782715 1.999997735023499 Z M 5.386369228363037 1.999997735023499 L 0.99998939037323 1.999997735023499 C 0.5285893678665161 1.999997735023499 -6.310272055998212e-07 1.471417784690857 -6.310272055998212e-07 1.000007748603821 C -6.310272055998212e-07 0.5285977721214294 0.5285893678665161 1.774860356817953e-05 0.99998939037323 1.774860356817953e-05 L 4.386369228363037 1.774860356817953e-05 C 5.136264324188232 1.774860356817953e-05 5.958448886871338 0.668719470500946 6.263566493988037 1.416796207427979 C 6.079687118530273 1.737106442451477 5.71880054473877 1.999997735023499 5.386369228363037 1.999997735023499 Z",
    stroke: "none",
    fill: "#1a3f54"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(64.307 31.5) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_Copy_6",
    "data-name": "Path Copy 6",
    transform: "translate(2.193 41.807) rotate(90)",
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.386,2a2.25,2.25,0,0,0-2-2H1A1.125,1.125,0,0,0,0,1H0A1.125,1.125,0,0,0,1,2H5.386a1.125,1.125,0,0,0,1-1Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6.386359214782715 1.999997735023499 C 6.386359214782715 1.807042717933655 6.342076301574707 1.609283447265625 6.263566493988037 1.416796207427979 C 6.340435028076172 1.282894730567932 6.386359214782715 1.138979315757751 6.386359214782715 1.000007748603821 L 6.386359214782715 1.999997735023499 Z M 5.386369228363037 1.999997735023499 L 0.99998939037323 1.999997735023499 C 0.5285893678665161 1.999997735023499 -6.310272055998212e-07 1.471417784690857 -6.310272055998212e-07 1.000007748603821 C -6.310272055998212e-07 0.5285977721214294 0.5285893678665161 1.774860356817953e-05 0.99998939037323 1.774860356817953e-05 L 4.386369228363037 1.774860356817953e-05 C 5.136264324188232 1.774860356817953e-05 5.958448886871338 0.668719470500946 6.263566493988037 1.416796207427979 C 6.079687118530273 1.737106442451477 5.71880054473877 1.999997735023499 5.386369228363037 1.999997735023499 Z",
    stroke: "none",
    fill: "#1a3f54"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_Copy_5",
    "data-name": "Path Copy 5",
    transform: "translate(2.193 0.92) rotate(90)",
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.386,2a2.25,2.25,0,0,0-2-2H1A1.125,1.125,0,0,0,0,1H0A1.125,1.125,0,0,0,1,2H5.386a1.125,1.125,0,0,0,1-1Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6.386359214782715 1.999997735023499 C 6.386359214782715 1.807042717933655 6.342076301574707 1.609283447265625 6.263566493988037 1.416796207427979 C 6.340435028076172 1.282894730567932 6.386359214782715 1.138979315757751 6.386359214782715 1.000007748603821 L 6.386359214782715 1.999997735023499 Z M 5.386369228363037 1.999997735023499 L 0.99998939037323 1.999997735023499 C 0.5285893678665161 1.999997735023499 -6.310272055998212e-07 1.471417784690857 -6.310272055998212e-07 1.000007748603821 C -6.310272055998212e-07 0.5285977721214294 0.5285893678665161 1.774860356817953e-05 0.99998939037323 1.774860356817953e-05 L 4.386369228363037 1.774860356817953e-05 C 5.136264324188232 1.774860356817953e-05 5.958448886871338 0.668719470500946 6.263566493988037 1.416796207427979 C 6.079687118530273 1.737106442451477 5.71880054473877 1.999997735023499 5.386369228363037 1.999997735023499 Z",
    stroke: "none",
    fill: "#1a3f54"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Path",
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69,0H10.5A10.907,10.907,0,0,0,0,10.5v44A10.907,10.907,0,0,0,10.5,65h59c5.5,0,10.5-5,10.5-11l0-43.5C80,5,75,0,69,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 10.49800109863281 2.000499725341797 C 8.403938293457031 2.000499725341797 6.254722595214844 2.948699951171875 4.601463317871094 4.601963043212891 C 2.948204040527344 6.255222320556641 2 8.404438018798828 2 10.49850082397461 L 2 54.49725341796875 C 2 56.59131622314453 2.948204040527344 58.74051666259766 4.601463317871094 60.39377593994141 C 6.254722595214844 62.04703903198242 8.403938293457031 62.9952392578125 10.49800109863281 62.9952392578125 L 69.49675750732422 62.9952392578125 C 71.60386657714844 62.9952392578125 73.74491119384766 62.03242492675781 75.37089538574219 60.35366821289063 C 77.06291198730469 58.60673141479492 77.99475860595703 56.3482551574707 77.99475860595703 53.99402236938477 L 77.9996337890625 10.49799346923828 C 77.9996337890625 8.390884399414063 77.03681945800781 6.249839782714844 75.35804748535156 4.623855590820313 C 73.63467407226563 2.954662322998047 71.41336822509766 2.0252685546875 69.09374237060547 2.000499725341797 L 68.99924468994141 2.000499725341797 L 10.49800109863281 2.000499725341797 M 68.99863433837891 -7.62939453125e-06 C 74.9996337890625 -7.62939453125e-06 79.9996337890625 4.999992370605469 79.9996337890625 10.49799346923828 L 79.99475860595703 53.99425506591797 C 79.99475860595703 59.99525451660156 74.99475860595703 64.9952392578125 69.49675750732422 64.9952392578125 L 10.49800109863281 64.9952392578125 C 5 64.9952392578125 0 59.99525451660156 0 54.49725341796875 L 0 10.49850082397461 C 0 5.000499725341797 5 0.0005035400390625 10.49800109863281 0.0005035400390625 L 68.99924468994141 0.0005035400390625 L 68.99863433837891 -7.62939453125e-06 Z",
    stroke: "none",
    fill: "#3f8fc1"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Oval",
    d: "M3.48,28.1A17.363,17.363,0,0,0,18,36,18,18,0,1,0,0,18",
    transform: "translate(63.432 41.946) rotate(158)",
    fill: "none",
    stroke: "#1a3f54",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Oval_Copy",
    "data-name": "Oval Copy",
    d: "M16,8A8,8,0,1,0,0,8",
    transform: "translate(48 39.564) rotate(180)",
    fill: "none",
    stroke: "#f27a76",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Oval_Copy_2",
    "data-name": "Oval Copy 2",
    d: "M0,0A7.717,7.717,0,0,0,6.453,3.513",
    transform: "matrix(-0.891, 0.454, -0.454, -0.891, 43.713, 25.073)",
    fill: "none",
    stroke: "#f27a76",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(30 35) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3_Copy",
    "data-name": "Path 3 Copy",
    d: "M0,27.213V.069L12.936,0",
    transform: "translate(0.88 9.951) rotate(-45)",
    fill: "none",
    stroke: "#f27a76",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoals);
export default __webpack_public_path__ + "static/media/Goals.a4ddb1c66c7aeaa8c6526e938357e48b.svg";
export { ForwardRef as ReactComponent };